import {
    CREATE_COMMENT,
    DELETE_COMMENT,
    EDIT_COMMENT,
    GET_COMMENTS,
    GET_MENTION_STAFF,
} from './comment.type';

/**
 * List a resource's comments. Always fetched flat (top-level + replies in one
 * shot) so the panel can build the reply tree client-side.
 * @param {string} onModel     CommentOnModel value ('claim', 'bill', 'funder', ...)
 * @param {string} resourceId  the resource's Mongo id
 * @param {object} params      { skip, limit, flat, parentComment }
 * @param {string} load        pass 'noLoad' to suppress the global spinner
 */
export const getComments = (onModel, resourceId, params, load) => {
    return { type: GET_COMMENTS, payload: { onModel, resourceId, params, load } };
};

/**
 * Create a comment (or a reply when body.parentComment is set).
 * @param {object} body           { onModel, resourceId, text, parentComment?, attachments? }
 * @param {object} requestParams  when present, the saga refetches that thread
 *                                after a successful create ({ onModel, resourceId, params }).
 */
export const createComment = (body, requestParams) => {
    return { type: CREATE_COMMENT, payload: { body, requestParams } };
};

export const editComment = (id, body, requestParams) => {
    return { type: EDIT_COMMENT, payload: { id, body, requestParams } };
};

export const deleteComment = (id, requestParams) => {
    return { type: DELETE_COMMENT, payload: { id, requestParams } };
};

/**
 * Search staff for the @mention autocomplete (server-side, paginated).
 * @param {object} opts
 * @param {string} opts.search  name query typed after `@`
 * @param {number} opts.page    1-based page; page 1 replaces the list, page > 1 appends
 * @param {string} opts.load    pass 'noLoad' (default) to suppress the global spinner
 */
export const getMentionStaff = ({ search = '', page = 1, load = 'noLoad' } = {}) => {
    return { type: GET_MENTION_STAFF, payload: { search, page, load } };
};
